/*!
 * @sphinxxxx/color-conversion v2.2.2
 * https://github.com/Sphinxxxx/color-conversion
 *
 * Copyright 2017-2019 Joudee (https://github.com/Joudee), Andreas Borgen (https://github.com/Sphinxxxx), Michael Jackson (https://github.com/mjackson)
 * Released under the ISC license.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Color = factory();
})(this, function () {
  'use strict';

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  String.prototype.startsWith = String.prototype.startsWith || function (needle) {
    return this.indexOf(needle) === 0;
  };

  String.prototype.padStart = String.prototype.padStart || function (len, pad) {
    var str = this;

    while (str.length < len) {
      str = pad + str;
    }

    return str;
  };

  var colorNames = {
    cb: '0f8ff',
    tqw: 'aebd7',
    q: '-ffff',
    qmrn: '7fffd4',
    zr: '0ffff',
    bg: '5f5dc',
    bsq: 'e4c4',
    bck: '---',
    nch: 'ebcd',
    b: '--ff',
    bvt: '8a2be2',
    brwn: 'a52a2a',
    brw: 'deb887',
    ctb: '5f9ea0',
    hrt: '7fff-',
    chcT: 'd2691e',
    cr: '7f50',
    rnw: '6495ed',
    crns: '8dc',
    crms: 'dc143c',
    cn: '-ffff',
    Db: '--8b',
    Dcn: '-8b8b',
    Dgnr: 'b8860b',
    Dgr: 'a9a9a9',
    Dgrn: '-64-',
    Dkhk: 'bdb76b',
    Dmgn: '8b-8b',
    Dvgr: '556b2f',
    Drng: '8c-',
    Drch: '9932cc',
    Dr: '8b--',
    Dsmn: 'e9967a',
    Dsgr: '8fbc8f',
    DsTb: '483d8b',
    DsTg: '2f4f4f',
    Dtrq: '-ced1',
    Dvt: '94-d3',
    ppnk: '1493',
    pskb: '-bfff',
    mgr: '696969',
    grb: '1e90ff',
    rbrc: 'b22222',
    rwht: 'af0',
    stg: '228b22',
    chs: '-ff',
    gnsb: 'dcdcdc',
    st: '8f8ff',
    g: 'd7-',
    gnr: 'daa520',
    gr: '808080',
    grn: '-8-0',
    grnw: 'adff2f',
    hnw: '0fff0',
    htpn: '69b4',
    nnr: 'cd5c5c',
    ng: '4b-82',
    vr: '0',
    khk: '0e68c',
    vnr: 'e6e6fa',
    nrb: '0f5',
    wngr: '7cfc-',
    mnch: 'acd',
    Lb: 'add8e6',
    Lcr: '08080',
    Lcn: 'e0ffff',
    Lgnr: 'afad2',
    Lgr: 'd3d3d3',
    Lgrn: '90ee90',
    Lpnk: 'b6c1',
    Lsmn: 'a07a',
    Lsgr: '20b2aa',
    Lskb: '87cefa',
    LsTg: '778899',
    Lstb: 'b0c4de',
    Lw: 'e0',
    m: '-ff-',
    mgrn: '32cd32',
    nn: 'af0e6',
    mgnt: '-ff',
    mrn: '8--0',
    mqm: '66cdaa',
    mmb: '--cd',
    mmrc: 'ba55d3',
    mmpr: '9370db',
    msg: '3cb371',
    mmsT: '7b68ee',
    '': '-fa9a',
    mtr: '48d1cc',
    mmvt: 'c71585',
    mnLb: '191970',
    ntc: '5fffa',
    mstr: 'e4e1',
    mccs: 'e4b5',
    vjw: 'dead',
    nv: '--80',
    c: 'df5e6',
    v: '808-0',
    vrb: '6b8e23',
    rng: 'a5-',
    rngr: '45-',
    rch: 'da70d6',
    pgnr: 'eee8aa',
    pgrn: '98fb98',
    ptrq: 'afeeee',
    pvtr: 'db7093',
    ppwh: 'efd5',
    pchp: 'dab9',
    pr: 'cd853f',
    pnk: 'c0cb',
    pm: 'dda0dd',
    pwrb: 'b0e0e6',
    prp: '8-080',
    cc: '663399',
    r: '--',
    sbr: 'bc8f8f',
    rb: '4169e1',
    sbrw: '8b4513',
    smn: 'a8072',
    nbr: '4a460',
    sgrn: '2e8b57',
    ssh: '5ee',
    snn: 'a0522d',
    svr: 'c0c0c0',
    skb: '87ceeb',
    sTb: '6a5acd',
    sTgr: '708090',
    snw: 'afa',
    n: '-ff7f',
    stb: '4682b4',
    tn: 'd2b48c',
    t: '-8080',
    thst: 'd8bfd8',
    tmT: '6347',
    trqs: '40e0d0',
    vt: 'ee82ee',
    whT: '5deb3',
    wht: '',
    hts: '5f5f5',
    w: '-',
    wgrn: '9acd32'
  };

  function printNum(num) {
    var decs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var str = decs > 0 ? num.toFixed(decs).replace(/0+$/, '').replace(/\.$/, '') : num.toString();
    return str || '0';
  }

  var Color = function () {
    function Color(r, g, b, a) {
      classCallCheck(this, Color);
      var that = this;

      function parseString(input) {
        if (input.startsWith('hsl')) {
          var _input$match$map = input.match(/([\-\d\.e]+)/g).map(Number),
              _input$match$map2 = slicedToArray(_input$match$map, 4),
              h = _input$match$map2[0],
              s = _input$match$map2[1],
              l = _input$match$map2[2],
              _a = _input$match$map2[3];

          if (_a === undefined) {
            _a = 1;
          }

          h /= 360;
          s /= 100;
          l /= 100;
          that.hsla = [h, s, l, _a];
        } else if (input.startsWith('rgb')) {
          var _input$match$map3 = input.match(/([\-\d\.e]+)/g).map(Number),
              _input$match$map4 = slicedToArray(_input$match$map3, 4),
              _r = _input$match$map4[0],
              _g = _input$match$map4[1],
              _b = _input$match$map4[2],
              _a2 = _input$match$map4[3];

          if (_a2 === undefined) {
            _a2 = 1;
          }

          that.rgba = [_r, _g, _b, _a2];
        } else {
          if (input.startsWith('#')) {
            that.rgba = Color.hexToRgb(input);
          } else {
            that.rgba = Color.nameToRgb(input) || Color.hexToRgb(input);
          }
        }
      }

      if (r === undefined) {} else if (Array.isArray(r)) {
        this.rgba = r;
      } else if (b === undefined) {
        var color = r && '' + r;

        if (color) {
          parseString(color.toLowerCase());
        }
      } else {
        this.rgba = [r, g, b, a === undefined ? 1 : a];
      }
    }

    createClass(Color, [{
      key: 'printRGB',
      value: function printRGB(alpha) {
        var rgb = alpha ? this.rgba : this.rgba.slice(0, 3),
            vals = rgb.map(function (x, i) {
          return printNum(x, i === 3 ? 3 : 0);
        });
        return alpha ? 'rgba(' + vals + ')' : 'rgb(' + vals + ')';
      }
    }, {
      key: 'printHSL',
      value: function printHSL(alpha) {
        var mults = [360, 100, 100, 1],
            suff = ['', '%', '%', ''];
        var hsl = alpha ? this.hsla : this.hsla.slice(0, 3),
            vals = hsl.map(function (x, i) {
          return printNum(x * mults[i], i === 3 ? 3 : 1) + suff[i];
        });
        return alpha ? 'hsla(' + vals + ')' : 'hsl(' + vals + ')';
      }
    }, {
      key: 'printHex',
      value: function printHex(alpha) {
        var hex = this.hex;
        return alpha ? hex : hex.substring(0, 7);
      }
    }, {
      key: 'rgba',
      get: function get$$1() {
        if (this._rgba) {
          return this._rgba;
        }

        if (!this._hsla) {
          throw new Error('No color is set');
        }

        return this._rgba = Color.hslToRgb(this._hsla);
      },
      set: function set$$1(rgb) {
        if (rgb.length === 3) {
          rgb[3] = 1;
        }

        this._rgba = rgb;
        this._hsla = null;
      }
    }, {
      key: 'rgbString',
      get: function get$$1() {
        return this.printRGB();
      }
    }, {
      key: 'rgbaString',
      get: function get$$1() {
        return this.printRGB(true);
      }
    }, {
      key: 'hsla',
      get: function get$$1() {
        if (this._hsla) {
          return this._hsla;
        }

        if (!this._rgba) {
          throw new Error('No color is set');
        }

        return this._hsla = Color.rgbToHsl(this._rgba);
      },
      set: function set$$1(hsl) {
        if (hsl.length === 3) {
          hsl[3] = 1;
        }

        this._hsla = hsl;
        this._rgba = null;
      }
    }, {
      key: 'hslString',
      get: function get$$1() {
        return this.printHSL();
      }
    }, {
      key: 'hslaString',
      get: function get$$1() {
        return this.printHSL(true);
      }
    }, {
      key: 'hex',
      get: function get$$1() {
        var rgb = this.rgba,
            hex = rgb.map(function (x, i) {
          return i < 3 ? x.toString(16) : Math.round(x * 255).toString(16);
        });
        return '#' + hex.map(function (x) {
          return x.padStart(2, '0');
        }).join('');
      },
      set: function set$$1(hex) {
        this.rgba = Color.hexToRgb(hex);
      }
    }], [{
      key: 'hexToRgb',
      value: function hexToRgb(input) {
        var hex = (input.startsWith('#') ? input.slice(1) : input).replace(/^(\w{3})$/, '$1F').replace(/^(\w)(\w)(\w)(\w)$/, '$1$1$2$2$3$3$4$4').replace(/^(\w{6})$/, '$1FF');

        if (!hex.match(/^([0-9a-fA-F]{8})$/)) {
          throw new Error('Unknown hex color; ' + input);
        }

        var rgba = hex.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function (x) {
          return parseInt(x, 16);
        });
        rgba[3] = rgba[3] / 255;
        return rgba;
      }
    }, {
      key: 'nameToRgb',
      value: function nameToRgb(input) {
        var hash = input.toLowerCase().replace('at', 'T').replace(/[aeiouyldf]/g, '').replace('ght', 'L').replace('rk', 'D').slice(-5, 4),
            hex = colorNames[hash];
        return hex === undefined ? hex : Color.hexToRgb(hex.replace(/\-/g, '00').padStart(6, 'f'));
      }
    }, {
      key: 'rgbToHsl',
      value: function rgbToHsl(_ref) {
        var _ref2 = slicedToArray(_ref, 4),
            r = _ref2[0],
            g = _ref2[1],
            b = _ref2[2],
            a = _ref2[3];

        r /= 255;
        g /= 255;
        b /= 255;
        var max = Math.max(r, g, b),
            min = Math.min(r, g, b);
        var h = void 0,
            s = void 0,
            l = (max + min) / 2;

        if (max === min) {
          h = s = 0;
        } else {
          var d = max - min;
          s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

          switch (max) {
            case r:
              h = (g - b) / d + (g < b ? 6 : 0);
              break;

            case g:
              h = (b - r) / d + 2;
              break;

            case b:
              h = (r - g) / d + 4;
              break;
          }

          h /= 6;
        }

        return [h, s, l, a];
      }
    }, {
      key: 'hslToRgb',
      value: function hslToRgb(_ref3) {
        var _ref4 = slicedToArray(_ref3, 4),
            h = _ref4[0],
            s = _ref4[1],
            l = _ref4[2],
            a = _ref4[3];

        var r = void 0,
            g = void 0,
            b = void 0;

        if (s === 0) {
          r = g = b = l;
        } else {
          var hue2rgb = function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
          };

          var q = l < 0.5 ? l * (1 + s) : l + s - l * s,
              p = 2 * l - q;
          r = hue2rgb(p, q, h + 1 / 3);
          g = hue2rgb(p, q, h);
          b = hue2rgb(p, q, h - 1 / 3);
        }

        var rgba = [r * 255, g * 255, b * 255].map(Math.round);
        rgba[3] = a;
        return rgba;
      }
    }]);
    return Color;
  }();

  return Color;
});